/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class Product {

    id: number;
    uuid: string;
    description: string;

    name: string;
    price: number;
    productType: any = 'SERVICE';
    taxType: string = '2';
    taxFactor: number = 15;
    icon: string;
    photo: string;

    //Auxiliares
    amount: number = 1;
    color: string;
    
    //Código de terceros para auditoria
    codigoPrincipal: string;
    codigoAuxiliar: string;
    
    estab:string;
}